import React, { useRef, useCallback, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Canon Corp Campaign — CORALS (World Unseen) aylık medya planları.
 * Tek bileşen, `month` prop'u ile Haziran / Temmuz / Ağustos 2026 sürümlerini üretir.
 * Bütçe her ay aynı (40.000 ₺); ayıran şey o ayın GERÇEKLEŞEN Canon CPM/CPC'si ve gün sayısı.
 *
 * 2026-08-24 revizyonu: KPI global'den web sitesinin ilgili alanına YÖNLENDİRME olduğu için
 * üç videonun da hedefi TRAFİK. Awareness kırılımı plandan tamamen çıkarıldı.
 *
 * CPM/CPC değerleri uydurma DEĞİL: Canon'un kendi Meta hesabının (act_3256944827800966)
 * canlı Graph API verisinden, LINK_CLICKS hedefli kampanyaların ay bazlı gerçekleşmesinden alındı.
 * CPC = inline_link_click başına maliyet (tüm tıklama değil).
 *
 * 2026-08-24 · yerleşim düzeltmesi: aylar arasındaki fark büyük ölçüde YERLEŞİM KARMASINDAN
 * geliyordu — Temmuz'da trafik bütçesinin %45'i Story'ye gitmiş (Ağustos'ta %13), Story ise
 * feed+reels'in ~1,6 katı CPC üretiyor. Plan tabanı bu yüzden yalnızca FEED + REELS
 * yerleşimlerinden alındı; Story hariç tutuldu. Eşitlenince aylar birbirine yaklaşıyor.
 */

// O ayın Canon hesabında TRAFİK hedefiyle GERÇEKLEŞEN değerleri.
// Yayın kurgusu (Merve brief'i, 2026-09-10): her ay 3 içerik, her biri TRAFİK
// hedefiyle ve 5 gün yayında. Uçuşlar ayın 1'i, 11'i ve 21'inde açılıyor; ay
// başı / ortası / sonu böylece ayrı ayrı kapsanıyor.
export const CORALS_MONTHS_ORDER = ['haziran','temmuz','agustos','eylul','ekim','kasim','aralik'];

const MONTHS = {
  haziran: {
    label: 'Haziran 2026',
    short: 'Haz',
    slug: 'haziran',
    start: '2026-06-01',
    end: '2026-06-30',
    days: 30,
    trCpm: 32.02,
    trCpc: 1.61,
    trCtr: 1.98,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 1427,
    storyPct: 42,
    flights: {
      v1: { start: '2026-06-01', end: '2026-06-05' },
      v2: { start: '2026-06-11', end: '2026-06-15' },
      v3: { start: '2026-06-21', end: '2026-06-25' },
    },
    marks: [
      { label: '1 Haz', date: '2026-06-01' },
      { label: '11 Haz', date: '2026-06-11' },
      { label: '21 Haz', date: '2026-06-21' },
      { label: '30 Haz', date: '2026-06-30' },
    ],
    note: 'Feed + Reels bazında ölçülen ayların en pahalı gösterimi (₺32,02), buna karşılık tıklaması ucuz (₺1,61). Bu ayın feed+reels örneklemi yalnızca 1.427 ₺ harcamaya dayanıyor — sapma payı açık ara en yüksek ay bu.',
  },
  temmuz: {
    label: 'Temmuz 2026',
    short: 'Tem',
    slug: 'temmuz',
    start: '2026-07-01',
    end: '2026-07-31',
    days: 31,
    trCpm: 28.43,
    trCpc: 2.18,
    trCtr: 1.31,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 133361,
    storyPct: 45,
    flights: {
      v1: { start: '2026-07-01', end: '2026-07-05' },
      v2: { start: '2026-07-11', end: '2026-07-15' },
      v3: { start: '2026-07-21', end: '2026-07-25' },
    },
    marks: [
      { label: '1 Tem', date: '2026-07-01' },
      { label: '11 Tem', date: '2026-07-11' },
      { label: '21 Tem', date: '2026-07-21' },
      { label: '31 Tem', date: '2026-07-31' },
    ],
    note: "Ham rakamlara bakıldığında bu ay çok pahalı görünüyordu (CPC ₺2,63); sebebi ay değil yerleşimdi — trafik bütçesinin %45'i Story'ye gitmiş, Story ise feed+reels'in ~1,6 katı tıklama maliyeti üretiyor. Aynı yerleşimde kıyaslanınca fark kapanıyor: CPM ₺28,43, CPC ₺2,18. Dayanağı açık ara en sağlam ay: 133.361 ₺ feed+reels harcaması.",
  },
  agustos: {
    label: 'Ağustos 2026',
    short: 'Ağu',
    slug: 'agustos',
    start: '2026-08-01',
    end: '2026-08-31',
    days: 31,
    trCpm: 25.03,
    trCpc: 1.38,
    trCtr: 1.82,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 42049,
    storyPct: 13,
    flights: {
      v1: { start: '2026-08-01', end: '2026-08-05' },
      v2: { start: '2026-08-11', end: '2026-08-15' },
      v3: { start: '2026-08-21', end: '2026-08-25' },
    },
    marks: [
      { label: '1 Ağu', date: '2026-08-01' },
      { label: '11 Ağu', date: '2026-08-11' },
      { label: '21 Ağu', date: '2026-08-21' },
      { label: '31 Ağu', date: '2026-08-31' },
    ],
    note: "Aynı bütçenin en çok iş çıkardığı ay: feed+reels CPM'i ₺25,03'e, tıklama ₺1,38'e düştüğü için hem gösterim hem link tıklaması ölçülen ayların en yükseği. Bütçenin yalnızca %13'ü Story'ye gitmiş — karma da plana en yakın ay bu.",
  },
  eylul: {
    label: 'Eylül 2026',
    short: 'Eyl',
    slug: 'eylul',
    start: '2026-09-01',
    end: '2026-09-30',
    days: 30,
    trCpm: 43.9,
    trCpc: 3.1,
    trCtr: 1.41,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 27473,
    storyPct: 18,
    flights: {
      v1: { start: '2026-09-01', end: '2026-09-05' },
      v2: { start: '2026-09-11', end: '2026-09-15' },
      v3: { start: '2026-09-21', end: '2026-09-25' },
    },
    marks: [
      { label: '1 Eyl', date: '2026-09-01' },
      { label: '11 Eyl', date: '2026-09-11' },
      { label: '21 Eyl', date: '2026-09-21' },
      { label: '30 Eyl', date: '2026-09-30' },
    ],
    note: "Ölçülen dört ayın en pahalı gösterimi: feed+reels CPM ₺43,90, tıklama ₺3,10 — Ağustos'un ₺25,03 / ₺1,38'inin yaklaşık 1,8 ve 2,2 katı. Sebebi yerleşim karması değil (Story payı %18, Ağustos'un %13'üne yakın); açık artırma Eylül'de sertleşmiş ve Back to School akışı aynı kitleye baskı yapıyor. ⚠️ Bu rakamlar ayın ilk 8 gününün 27.473 ₺ feed+reels harcamasına dayanıyor; ay kapandığında tazelenmeli.",
  },
  ekim: {
    label: 'Ekim 2026',
    short: 'Eki',
    slug: 'ekim',
    start: '2026-10-01',
    end: '2026-10-31',
    days: 31,
    forecast: true,
    trCpm: 29.84,
    trCpc: 2.14,
    trCtr: 1.43,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 204310,
    flights: {
      v1: { start: '2026-10-01', end: '2026-10-05' },
      v2: { start: '2026-10-11', end: '2026-10-15' },
      v3: { start: '2026-10-21', end: '2026-10-25' },
    },
    marks: [
      { label: '1 Eki', date: '2026-10-01' },
      { label: '11 Eki', date: '2026-10-11' },
      { label: '21 Eki', date: '2026-10-21' },
      { label: '31 Eki', date: '2026-10-31' },
    ],
    note: "⚠️ Tahmin ayı — Canon hesabında Ekim gerçekleşmesi henüz yok. Taban, ölçülen dört ayın örneklem ağırlıklı ortalaması: 204.310 ₺ feed+reels harcaması üzerinden CPM ₺29,84, CPC ₺2,14. Hesap Nisan 2026'da açıldığı için geçen yılın Ekim'i de yok, yani mevsimsel bir artış katsayısı ölçüye dayandırılamıyor ve bilerek uygulanmadı.",
  },
  kasim: {
    label: 'Kasım 2026',
    short: 'Kas',
    slug: 'kasim',
    start: '2026-11-01',
    end: '2026-11-30',
    days: 30,
    forecast: true,
    trCpm: 29.84,
    trCpc: 2.14,
    trCtr: 1.43,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 204310,
    flights: {
      v1: { start: '2026-11-01', end: '2026-11-05' },
      v2: { start: '2026-11-11', end: '2026-11-15' },
      v3: { start: '2026-11-21', end: '2026-11-25' },
    },
    marks: [
      { label: '1 Kas', date: '2026-11-01' },
      { label: '11 Kas', date: '2026-11-11' },
      { label: '21 Kas', date: '2026-11-21' },
      { label: '30 Kas', date: '2026-11-30' },
    ],
    note: "⚠️ Tahmin ayı — aynı taban (CPM ₺29,84, CPC ₺2,14) düz taşındı. Kasım'da Black Friday açık artırmayı sertleştirir ve Eylül'de gördüğümüz gibi maliyet iki katına kadar çıkabilir; ancak Canon hesabında bunu ölçecek geçmiş Kasım verisi olmadığı için plana katsayı yazılmadı. Rakamlar tavan değil taban okunmalı.",
  },
  aralik: {
    label: 'Aralık 2026',
    short: 'Ara',
    slug: 'aralik',
    start: '2026-12-01',
    end: '2026-12-31',
    days: 31,
    forecast: true,
    trCpm: 29.84,
    trCpc: 2.14,
    trCtr: 1.43,
    // örneklem büyüklüğü (₺, feed+reels) — dipnotta gösterilir
    trSample: 204310,
    flights: {
      v1: { start: '2026-12-01', end: '2026-12-05' },
      v2: { start: '2026-12-11', end: '2026-12-15' },
      v3: { start: '2026-12-21', end: '2026-12-25' },
    },
    marks: [
      { label: '1 Ara', date: '2026-12-01' },
      { label: '11 Ara', date: '2026-12-11' },
      { label: '21 Ara', date: '2026-12-21' },
      { label: '31 Ara', date: '2026-12-31' },
    ],
    note: "⚠️ Tahmin ayı — aynı taban (CPM ₺29,84, CPC ₺2,14) düz taşındı. Yılbaşı dönemi Kasım'la birlikte yılın en pahalı açık artırma penceresidir; ölçüye dayanmadığı için katsayı uygulanmadı. Aralık planı, Ekim ve Kasım kapandıkça mutlaka tazelenmeli.",
  },
};

// Canon'un TRAFİK hedefli, GERÇEK video kreatifli kampanyalarının birleşik gerçekleşmesi
// (Haz–Ağu 2026, 4 kampanya, 11.247 ₺ harcama, 210.704 gösterim — canlı Graph API).
// Adında "Video" geçen ama statik görselli yarışma kampanyaları ayıklandı; ayıklama
// sinyali izlenme oranının %1'in üzerinde olması.
const VIDEO_VIEW_RATE = 0.1918;   // 3 sn+ izlenme / gösterim
const VIDEO_THRU_RATE = 0.0556;   // ThruPlay / gösterim
const LPV_PER_LINK = 0.239;       // landing page view / link tıklaması
// Duyarlılık senaryosu da FEED + REELS bazında (plan tabanıyla aynı yerleşim).
const VIDEO_SAMPLE = 5581;        // ₺
const VIDEO_CPM = 49.12;
const VIDEO_CPC = 2.82;

// Planlama frekansı: bu plana en yakın harcama seviyesindeki gerçekleşmeden alındı
// (Ağustos trafik, 48.193 ₺ → 1,66). Temmuz'un 2,08'i 240.889 ₺ harcamaya ait, bu bütçeyi temsil etmez.
const PLAN_FREQ = 1.7;

// Kitle katmanı renkleri (üç videonun da hedefi Trafik).
const LAYER_TONE = { v1: '#CC0000', v2: '#6366f1', v3: '#0d9488' };

export const CORALS_MONTHS = MONTHS;

export default function CanonCoralsMonthly({ month = 'haziran', embedded = false }) {
  const M = MONTHS[month] || MONTHS.haziran;
  const slideRef = useRef(null);
  const [exporting, setExporting] = useState(false);

  const fmtCur = (n) => '₺' + Math.round(Number(n)).toLocaleString('tr-TR');
  const fmtInt = (n) => Math.round(Number(n)).toLocaleString('tr-TR');

  // ── Bütçe (her ay aynı) ───────────────────────────────────────────────────
  const TOTAL = 40000;
  const AHK_FEE = Math.round(TOTAL * 0.10);        // 4.000
  const MEDIA_BRUT = TOTAL - AHK_FEE;              // 36.000
  const STOPAJ = Math.round(MEDIA_BRUT * 0.15);    // 5.400
  const NET = MEDIA_BRUT - STOPAJ;                 // 30.600

  // Her içerik 5 gün yayında (Merve brief'i). Ayda 3 içerik → 15 yayın günü.
  const LIVE_DAYS = 5;
  const TOTAL_LIVE_DAYS = LIVE_DAYS * 3;
  const dailyNet = NET / TOTAL_LIVE_DAYS;

  // ── 3 video · hepsi TRAFİK, ayrışma kitle katmanında ──────────────────────
  const videos = [
    { key: 'v1', title: 'Video 1 — Ana Film', role: 'Projeyi tanıtan ana anlatım', layer: 'Geniş kitle · soğuk trafik', share: 0.40 },
    { key: 'v2', title: 'Video 2 — Hikâye', role: 'CORALS anlatısının derinleştirilmesi', layer: 'İlgi alanı + benzer kitle', share: 0.30 },
    { key: 'v3', title: 'Video 3 — Yönlendirme', role: 'World Unseen sayfasına net çağrı', layer: 'Retargeting · ilk iki videoyu izleyenler', share: null },
  ];

  let alloc = 0;
  const rows = videos.map((v, i) => {
    const isLast = i === videos.length - 1;
    const budget = isLast ? NET - alloc : Math.round(NET * v.share);
    alloc += budget;
    const flight = M.flights[v.key];
    const impressions = Math.round((budget / M.trCpm) * 1000);
    const clicks = Math.round(budget / M.trCpc);
    return {
      ...v,
      budget,
      flight,
      daily: budget / LIVE_DAYS,
      goal: 'Trafik',
      cpm: M.trCpm,
      cpc: M.trCpc,
      impressions,
      clicks,
      reach: Math.round(impressions / PLAN_FREQ),
      lpv: Math.round(clicks * LPV_PER_LINK),
      views: Math.round(impressions * VIDEO_VIEW_RATE),
      thruplays: Math.round(impressions * VIDEO_THRU_RATE),
    };
  });

  const totals = rows.reduce((t, r) => ({
    budget: t.budget + r.budget,
    impressions: t.impressions + r.impressions,
    clicks: t.clicks + r.clicks,
    lpv: t.lpv + r.lpv,
    views: t.views + r.views,
    thruplays: t.thruplays + r.thruplays,
  }), { budget: 0, impressions: 0, clicks: 0, lpv: 0, views: 0, thruplays: 0 });
  const blendedCpm = (totals.budget / totals.impressions) * 1000;
  const blendedCpc = totals.budget / totals.clicks;
  const cpv = totals.budget / totals.views;
  const cptp = totals.budget / totals.thruplays;
  const cplpv = totals.budget / totals.lpv;
  const estReach = Math.round(totals.impressions / PLAN_FREQ);
  const ctr = (totals.clicks / totals.impressions) * 100;

  // Duyarlılık: plan 3 VİDEO kreatifiyle yayınlanacak. Canon'un trafik hedefli video
  // kampanyalarında gerçekleşen CPM (₺53,38) ay ortalamalarının üzerinde — kötü senaryo.
  const sensImpressions = Math.round((NET / VIDEO_CPM) * 1000);
  const sensClicks = Math.round(NET / VIDEO_CPC);
  const sensDelta = Math.round(((sensImpressions - totals.impressions) / totals.impressions) * 100);

  // ── Takvim ────────────────────────────────────────────────────────────────
  const TL_START = new Date(M.start);
  const TL_SPAN = (new Date(M.end) - TL_START) / 86400000;
  const tlPct = (d) => (((new Date(d) - TL_START) / 86400000) / TL_SPAN) * 100;
  const fmtDay = (d) => new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
  const flightLabel = (f) => `${fmtDay(f.start)} → ${fmtDay(f.end)}`;

  // PDF: her bölüm bütün halinde basılır; kalan yere sığmıyorsa yeni sayfaya atılır.
  const exportPdf = useCallback(async () => {
    if (exporting || !slideRef.current) return;
    setExporting(true);
    try {
      const root = slideRef.current;
      const headerEl = root.querySelector('[data-pdf-header]');
      const sectionEls = Array.from(root.querySelectorAll('[data-pdf-section]'));
      const shoot = (el) => html2canvas(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        width: el.offsetWidth,
        height: el.scrollHeight + 12,
        windowWidth: document.documentElement.clientWidth,
      });

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const MG = 8;
      const GAP = 6;
      const CW = pw - MG * 2;
      const BOTTOM = ph - MG - 6;

      const headerCanvas = await shoot(headerEl);
      const headerImg = headerCanvas.toDataURL('image/jpeg', 0.95);
      const headerH = (headerCanvas.height * CW) / headerCanvas.width;
      const TOP_Y = MG + headerH + GAP;
      const PAGE_H = BOTTOM - TOP_Y;

      let pages = 0;
      let y = 0;
      const startPage = () => {
        if (pages > 0) pdf.addPage();
        pages += 1;
        pdf.addImage(headerImg, 'JPEG', MG, MG, CW, headerH);
        y = TOP_Y;
      };

      const slice = (canvas, srcY, srcH) => {
        const c = document.createElement('canvas');
        c.width = canvas.width;
        c.height = srcH;
        const ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);
        return c.toDataURL('image/jpeg', 0.95);
      };

      startPage();
      for (const el of sectionEls) {
        const canvas = await shoot(el);
        const pxPerMm = canvas.width / CW;
        let srcY = 0;
        let remain = canvas.height / pxPerMm;
        while (remain > 0.5) {
          const avail = BOTTOM - y;
          if (remain <= avail) {
            const srcH = Math.round(remain * pxPerMm);
            pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', MG, y, CW, remain);
            y += remain + GAP;
            remain = 0;
            break;
          }
          if (remain <= PAGE_H) { startPage(); continue; }
          const srcH = Math.round(avail * pxPerMm);
          pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', MG, y, CW, avail);
          srcY += srcH;
          remain -= avail;
          startPage();
        }
      }

      for (let i = 1; i <= pages; i += 1) {
        pdf.setPage(i);
        pdf.setFontSize(7);
        pdf.setTextColor(150);
        pdf.text(`Canon CORALS — ${M.label} · Jellybon x Glowytics · ${i}/${pages}`, pw / 2, ph - MG + 2, { align: 'center' });
      }
      pdf.save(`Canon_CORALS_${M.slug}_2026_Medya_Plani.pdf`);
    } catch (e) {
      console.error('PDF export failed:', e);
    } finally {
      setExporting(false);
    }
  }, [exporting, M]);

  const Stat = ({ label, value, sub, tone = 'gray' }) => {
    const tones = {
      gray: 'border-gray-200 bg-gray-50 text-gray-800',
      red: 'border-red-100 bg-red-50 text-red-700',
      indigo: 'border-indigo-100 bg-indigo-50 text-indigo-700',
      green: 'border-emerald-100 bg-emerald-50 text-emerald-700',
      teal: 'border-teal-100 bg-teal-50 text-teal-700',
    };
    return (
      <div className={`rounded-xl border p-4 ${tones[tone]}`}>
        <span className="text-[10px] font-medium uppercase opacity-70">{label}</span>
        <p className="text-xl font-bold mt-1">{value}</p>
        {sub && <p className="text-[10px] opacity-60 mt-0.5">{sub}</p>}
      </div>
    );
  };

  const LayerPill = ({ layer, tone }) => (
    <span
      className="text-[9px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap"
      style={{ color: tone, borderColor: tone + '33', background: tone + '0f' }}
    >{layer}</span>
  );

  const kart = (
    <div ref={slideRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        {/* Header */}
        <div data-pdf-header className="bg-white border-b px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-12 w-auto object-contain" />
            <div className="h-8 w-px bg-gray-200" />
            <div>
              <p className="text-xs font-bold text-gray-800">Canon Corp Campaign — CORALS · {M.label} Medya Planı</p>
              <p className="text-[9px] text-gray-400">World Unseen · Meta Ads (FB + IG) · 3 Video · her biri {LIVE_DAYS} gün</p>
            </div>
          </div>
          <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-12 w-auto object-contain" />
        </div>

        <div className="p-6 space-y-6">
          {/* Kampanya detayı */}
          <div data-pdf-section className="rounded-xl border border-red-100 bg-red-50 p-4">
            <p className="text-sm font-bold text-gray-800">Kampanya Detayı — {M.label}</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Canon'un kurumsal <strong>World Unseen</strong> projesinin parçası olan
              <strong> Canon Corp Campaign — CORALS</strong> iletişimi. Facebook + Instagram,
              <strong> {fmtDay(M.start)} – {fmtDay(M.end)} 2026</strong>.
              Ay içinde <strong>3 içerik</strong> var ve her biri kendi trafik kampanyasıyla
              <strong> {LIVE_DAYS} gün</strong> yayında kalıyor: ayın 1'i, 11'i ve 21'i.
              Toplam yayın günü {TOTAL_LIVE_DAYS}, aradaki günler bilerek boş — bütçe üç pencereye
              yoğunlaştırılıyor, aya yayılmıyor.
              Global tarafın verdiği KPI <strong>web sitesinin ilgili alanına yönlendirme</strong> olduğu için
              üç kampanyanın da hedefi <strong>Trafik</strong>; birincil KPI <strong>link tıklaması</strong>,
              video izlenme derinliği ikincil okunur. Videolar aynı, ayrışan şey kitle katmanı.
            </p>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Bütçe her ay aynıdır ({fmtCur(TOTAL)}). Aylar arasındaki fark, o ayın Canon hesabında
              <strong> trafik hedefiyle gerçekleşen CPM ve tıklama maliyetinden</strong> gelir. {M.note}
            </p>
          </div>

          {/* Tahmin ayı uyarısı */}
          {M.forecast && (
            <div data-pdf-section className="rounded-xl border border-amber-200 bg-amber-50 p-4">
              <p className="text-sm font-bold text-amber-900">{M.label} — Tahmin Ayı</p>
              <p className="text-[11px] text-amber-900 mt-1.5 leading-relaxed">
                Bu ayın rakamları gerçekleşme değil <strong>projeksiyon</strong>. Taban, Haziran–Eylül 2026'da
                ölçülen dört ayın örneklem ağırlıklı ortalamasıdır: <strong>204.310 ₺</strong> feed + reels
                harcaması üzerinden <strong>CPM ₺29,84</strong>, <strong>CPC ₺2,14</strong>.
                Canon'un Meta hesabı <strong>Nisan 2026'da</strong> açıldığı için geçen yılın Ekim–Aralık'ı
                elimizde yok; mevsimsel bir artış katsayısı ölçüye dayandırılamadığından bilerek uygulanmadı.
                Kasım ve Aralık yılın en pahalı açık artırma penceresidir, dolayısıyla bu rakamlar
                <strong> tavan değil taban</strong> okunmalı. Her ay kapandıkça sayfa tazelenmeli.
              </p>
            </div>
          )}

          {/* Hedefleme */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Hedefleme</p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <Stat label="Hedef Kitle" value="5,1 – 6,0M" sub="WorldUnseen Coral v2 · kayıtlı kitle" tone="red" />
              <Stat label="Yaş" value="18 – 50" sub="minimum yaş 18" />
              <Stat label="Dil" value="TR + EN" sub="Turkish, English (UK/US)" />
              <Stat label="Platform" value="FB + IG" sub="Advantage+ açık" tone="teal" />
            </div>

            <div className="mt-3 rounded-xl border border-gray-200 p-3">
              <span className="text-[10px] font-medium uppercase text-gray-500">Kayıtlı Kitle — Meta Ads Manager</span>
              <p className="text-sm font-bold text-gray-800 mt-1">Canon Türkiye — WorldUnseen Coral — v2</p>
              <div className="mt-2 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-2 text-[11px]">
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Locations</span>
                  <span className="text-gray-700">Inclusion: Turkey</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Minimum age</span>
                  <span className="text-gray-700">18</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Age</span>
                  <span className="text-gray-700">18 – 50</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Language</span>
                  <span className="text-gray-700">Turkish, English (UK) or English (US)</span>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-5 pt-2 border-t border-gray-100">
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Estimated audience size</span>
                  <span className="text-sm font-bold text-gray-800 tabular-nums">5.100.000 – 6.000.000</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Audience definition</span>
                  <span className="text-[11px] text-emerald-700 font-semibold">Broad — geniş</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase text-gray-400 font-semibold">Advantage+ audience</span>
                  <span className="text-[11px] text-gray-700">Açık</span>
                </div>
              </div>
            </div>

            <div className="mt-3 rounded-xl border border-red-100 bg-red-50/60 p-3">
              <span className="text-[10px] font-medium uppercase text-red-700">People who match — Detailed targeting</span>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {['Nikon', 'Underwater photography', 'Seiko Epson', 'Canon EOS', 'Digital photography', 'Ocean', 'Nature photography', 'Sony Alpha', 'Fujifilm'].map((t) => (
                  <span key={t} className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-red-200 text-red-800">{t}</span>
                ))}
                <span className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-red-200 text-red-800">Field of study: Aquaculture</span>
                <span className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-red-200 text-red-800">Employers: Canon Inc.</span>
              </div>
            </div>

            <div className="mt-2 rounded-xl border border-indigo-100 bg-indigo-50/60 p-3">
              <span className="text-[10px] font-medium uppercase text-indigo-700">And must also match</span>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {['Snorkeling', 'Underwater diving', 'Environmental science', 'Scuba diving', 'Natural environment'].map((t) => (
                  <span key={t} className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-indigo-200 text-indigo-800">{t}</span>
                ))}
                <span className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-indigo-200 text-indigo-800">Field of study: Marine biology</span>
                <span className="text-[10px] px-2 py-0.5 rounded-md bg-white border border-indigo-200 text-indigo-800">Field of study: Oceanography</span>
              </div>
              <p className="text-[9px] text-gray-500 mt-2 leading-relaxed">
                İkinci katman zorunludur: reklam, üstteki havuzdan gelen kişiye ancak bu ilgilerden birini de
                taşıyorsa gösterilir. Sualtı ve deniz ekseni CORALS anlatısının kendi konusudur, dolayısıyla
                bu kampanyada daraltma değil odaklanmadır.
              </p>
            </div>

            <p className="text-[10px] text-gray-400 mt-2 leading-relaxed">
              Kitle, müşterinin Ads Manager ekranından birebir alınmıştır; ilgi alanı adları Meta'nın kendi
              etiketleri olduğu için çevrilmedi. Müşteri bu kitlenin geçen yıl iyi çalıştığını belirtiyor —
              Canon'un Meta hesabı Nisan 2026'da açıldığı için o dönemin gerçekleşmesi bizde yok, doğrulanamadı.
              Bu bütçeyle beklenen erişim {fmtInt(estReach)} kişi, yani kitlenin yaklaşık
              %{Math.round((estReach / 5550000) * 100)}'i — doygunluk riski yok, frekans {PLAN_FREQ} seviyesinde kalır.
            </p>
          </div>

          {/* Bütçe */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Bütçe Kırılımı</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <Stat label="Toplam Bütçe" value={fmtCur(TOTAL)} sub="müşteri toplam" />
              <Stat label="AHK (Ajans %10)" value={'-' + fmtCur(AHK_FEE)} sub={`${fmtCur(TOTAL)} × 0,10`} tone="indigo" />
              <Stat label="Stopaj (%15)" value={'-' + fmtCur(STOPAJ)} sub={`${fmtCur(MEDIA_BRUT)} × 0,15`} tone="indigo" />
              <Stat label="NET Medya" value={fmtCur(NET)} sub="Meta'da harcanan" tone="green" />
            </div>
            <p className="text-[10px] text-gray-400 mt-2">
              Yayın günü başına ortalama net harcama ≈ {fmtCur(dailyNet)} ({TOTAL_LIVE_DAYS} yayın günü;
              içerik başına {fmtCur(NET / 3)} / {LIVE_DAYS} gün). AHK + Stopaj toplam
              {' '}{fmtCur(TOTAL)}'ye dahildir. Brüt medya {fmtCur(MEDIA_BRUT)}. Tasarım kalemi bu kırılımda yoktur.
            </p>
          </div>

          {/* Video tablosu */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Video Bazında Bütçe ve Projeksiyon (3 Video)</p>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 uppercase text-[10px]">
                    <th className="text-left px-3 py-2 font-semibold">Video</th>
                    <th className="text-left px-3 py-2 font-semibold">Yayın</th>
                    <th className="text-right px-3 py-2 font-semibold">Bütçe (NET)</th>
                    <th className="text-right px-3 py-2 font-semibold">Gösterim</th>
                    <th className="text-right px-3 py-2 font-semibold">Link Tık</th>
                    <th className="text-right px-3 py-2 font-semibold">CPC</th>
                    <th className="text-right px-3 py-2 font-semibold">Video İzlenme</th>
                    <th className="text-right px-3 py-2 font-semibold">CPM</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {rows.map((r) => (
                    <tr key={r.key} className="hover:bg-gray-50">
                      <td className="px-3 py-2">
                        <p className="font-semibold text-gray-800 whitespace-nowrap">{r.title}</p>
                        <p className="text-[9px] text-gray-400">{r.role}</p>
                        <div className="mt-1"><LayerPill layer={r.layer} tone={LAYER_TONE[r.key]} /></div>
                      </td>
                      <td className="px-3 py-2 text-gray-500 whitespace-nowrap">
                        {flightLabel(r.flight)}
                        <span className="text-gray-300"> · {LIVE_DAYS}g</span>
                        <span className="block text-[9px] text-gray-400">günlük {fmtCur(r.daily)}</span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums font-semibold">
                        {fmtCur(r.budget)}
                        <span className="block text-[9px] font-normal text-gray-400">%{Math.round((r.budget / NET) * 100)}</span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.impressions)}</td>
                      <td className="px-3 py-2 text-right tabular-nums font-semibold text-indigo-700">{fmtInt(r.clicks)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpc.toFixed(2)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.views)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpm.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-red-50 font-bold text-gray-800">
                    <td className="px-3 py-2" colSpan={2}>TOPLAM</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtCur(totals.budget)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.impressions)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.clicks)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpc.toFixed(2)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.views)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpm.toFixed(2)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p className="text-[10px] text-gray-400 mt-2">
              <strong>Link Tık</strong> = siteye yönlendiren tıklama (Meta'da <em>inline link click</em>); tüm
              tıklamalar değil, KPI'ın karşılığı olan metrik budur. <strong>CPC</strong> bu tıklamanın maliyeti.
              <strong> Video İzlenme</strong> = 3 saniye ve üzeri. Tahmini erişim {fmtInt(estReach)}
              {' '}(~{PLAN_FREQ} frekans), ThruPlay ≈ {fmtInt(totals.thruplays)} (₺{cptp.toFixed(2)}),
              beklenen CTR %{ctr.toFixed(2)}.
            </p>
          </div>

          {/* Projeksiyon özeti */}
          <div data-pdf-section className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Stat label="Site Yönlendirme (Link Tık)" value={fmtInt(totals.clicks)} sub={`birincil KPI · CPC ₺${blendedCpc.toFixed(2)}`} tone="green" />
            <Stat label="Toplam Gösterim" value={fmtInt(totals.impressions)} sub={`CPM ₺${blendedCpm.toFixed(2)} · CTR %${ctr.toFixed(2)}`} tone="red" />
            <Stat label="Tahmini Erişim" value={fmtInt(estReach)} sub={`~${PLAN_FREQ} frekans`} tone="indigo" />
            <Stat label="Video İzlenme" value={fmtInt(totals.views)} sub={`3 sn+ · CPV ₺${cpv.toFixed(3)}`} tone="teal" />
          </div>

          {/* Takvim */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-1">Yayın Takvimi</p>
            <p className="text-[10px] text-gray-400 mb-3">
              Üç içerik de {LIVE_DAYS} gün yayında kalır ve arada onar günlük boşluk vardır: ayın 1'i, 11'i ve 21'i.
              Ana film ayı açar; hikâye videosu ortada, yönlendirme videosu ayın son penceresinde çalışır —
              ilk iki pencerenin izleyici havuzu o noktada retargeting için yeterli olur.
            </p>
            <div className="rounded-xl border border-gray-200 p-4 overflow-hidden">
              <div className="flex">
                <div className="w-40 md:w-56 shrink-0" />
                <div className="relative flex-1 h-4">
                  {M.marks.map((mk, i) => (
                    <span
                      key={mk.label}
                      className="absolute top-0 text-[9px] font-semibold text-gray-400 whitespace-nowrap"
                      style={{
                        left: `${tlPct(mk.date)}%`,
                        transform: i === 0 ? 'none' : i === M.marks.length - 1 ? 'translateX(-100%)' : 'translateX(-50%)',
                      }}
                    >
                      {mk.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="relative mt-1.5">
                <div className="absolute inset-0 flex pointer-events-none">
                  <div className="w-40 md:w-56 shrink-0" />
                  <div className="relative flex-1">
                    {M.marks.map((mk) => (
                      <div key={mk.label} className="absolute top-0 bottom-0 w-px bg-gray-100" style={{ left: `${tlPct(mk.date)}%` }} />
                    ))}
                  </div>
                </div>

                {rows.map((r) => {
                  const left = tlPct(r.flight.start);
                  const width = Math.max(tlPct(r.flight.end) - left, 2);
                  const nearEnd = left > 60;
                  return (
                    <div key={r.key} className="flex items-center h-12 relative">
                      <div className="w-40 md:w-56 shrink-0 pr-3">
                        <p className="text-[11px] font-semibold text-gray-800 whitespace-nowrap" style={{ lineHeight: '1.5' }}>{r.title}</p>
                        <div className="flex items-center justify-between gap-1">
                          <span className="text-[9px] text-gray-400">{r.goal}</span>
                          <span className="text-[9px] font-bold tabular-nums" style={{ color: LAYER_TONE[r.key] }}>
                            {fmtCur(r.budget)} · %{Math.round((r.budget / NET) * 100)}
                          </span>
                        </div>
                      </div>
                      <div className="relative flex-1 h-12">
                        <div className="absolute top-1/2 -translate-y-1/2" style={{ left: `${left}%`, width: `${width}%` }}>
                          <div className={`absolute bottom-full mb-1 whitespace-nowrap text-[8.5px] font-medium text-gray-500 ${nearEnd ? 'right-0' : 'left-0'}`}>
                            {flightLabel(r.flight)} · {LIVE_DAYS}g
                          </div>
                          <div className="h-4 rounded-full shadow-sm" style={{ background: LAYER_TONE[r.key] }} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex flex-wrap items-center justify-between gap-3 mt-4 pt-3 border-t border-gray-100">
                <div className="flex flex-wrap items-center gap-3">
                  {rows.map((r) => (
                    <span key={r.key} className="flex items-center gap-1.5 text-[9px] text-gray-500">
                      <span className="w-3 h-3 rounded-full" style={{ background: LAYER_TONE[r.key] }} />{r.layer}
                    </span>
                  ))}
                </div>
                <span className="text-[9px] text-gray-400">
                  Toplam paid: <strong className="text-gray-600">{fmtCur(NET)}</strong> · 3 × {LIVE_DAYS} = {TOTAL_LIVE_DAYS} yayın günü
                </span>
              </div>
            </div>
          </div>

          {/* Dayanak */}
          <div data-pdf-section className="rounded-xl border border-amber-100 bg-amber-50 p-4">
            <p className="text-sm font-bold text-gray-800">Projeksiyonun Dayanağı — {M.label}</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Aşağıdaki CPM ve CPC değerleri sektör ortalaması değil, <strong>Canon'un kendi Meta hesabında
              {' '}trafik hedefiyle gerçekleşen</strong> rakamlardır.
              {M.forecast && <> Bu ay henüz yayınlanmadığı için taban, <strong>Haziran–Eylül 2026'nın örneklem
              ağırlıklı ortalamasıdır</strong>; o ayların kendi gerçekleşmeleri toplanarak hesaplanmıştır.</>} Awareness kırılımı bu planda kullanılmaz.
              Rakamlar yalnızca <strong>Feed + Reels</strong> yerleşimlerinden alınmıştır — gerekçesi aşağıda.
            </p>
            <div className="overflow-x-auto rounded-lg border border-amber-200 bg-white mt-2">
              <table className="w-full text-[11px]">
                <thead>
                  <tr className="bg-amber-50/60 text-gray-500 uppercase text-[9px]">
                    <th className="text-left px-3 py-1.5 font-semibold">Kırılım</th>
                    <th className="text-right px-3 py-1.5 font-semibold">Gerçekleşen Harcama</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPM</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPC (link)</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CTR %</th>
                    <th className="text-right px-3 py-1.5 font-semibold">İzlenme %</th>
                    <th className="text-right px-3 py-1.5 font-semibold">ThruPlay %</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-amber-100">
                  <tr className="bg-amber-50/40">
                    <td className="px-3 py-1.5 font-semibold text-gray-800">
                      Trafik · Feed + Reels — {M.forecast ? 'Haziran–Eylül ağırlıklı ort.' : M.label}
                      <span className="font-normal text-gray-400"> (plan tabanı)</span>
                    </td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">{fmtCur(M.trSample)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺{M.trCpm.toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺{M.trCpc.toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%{M.trCtr.toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-300">—</td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-300">—</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-1.5 font-medium text-gray-700">Trafik × gerçek video kreatifi <span className="text-gray-400">(Feed + Reels, Haz–Ağu)</span></td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">{fmtCur(VIDEO_SAMPLE)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺{VIDEO_CPM.toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺{VIDEO_CPC.toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%1,74</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%{(VIDEO_VIEW_RATE * 100).toFixed(2)}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%{(VIDEO_THRU_RATE * 100).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              CPM, CPC ve CTR {M.forecast ? 'Haziran–Eylül ağırlıklı ortalamasından' : M.label + ' trafik kırılımından'}; video izlenme ve ThruPlay oranları aya göre
              bölünecek kadar veri olmadığı için Canon'un <strong>trafik hedefli, gerçek video kreatifli</strong>
              {' '}kampanya ortalamasından alınmıştır (adında “Video” geçen ama statik görselli yarışma
              kampanyaları hariç tutuldu).
              {!M.forecast && M.trSample < 10000 && (
                <> ⚠️ Bu ayın feed+reels kırılımı yalnızca {fmtCur(M.trSample)} harcamaya dayanıyor; plandaki
                tüm rakamlar bu ayda daha geniş bir sapma bandına sahiptir.</>
              )}
            </p>
          </div>

          {/* Yerleşim gerekçesi */}
          <div data-pdf-section className="rounded-xl border border-sky-200 bg-sky-50 p-4">
            <p className="text-sm font-bold text-gray-800">Neden Yalnızca Feed + Reels?</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Ham aylık rakamlara bakıldığında Temmuz diğer aylardan çok pahalı görünüyordu (CPC ₺2,63'e karşı
              Haziran ₺1,63, Ağustos ₺1,41). Kırılıma inilince fark ayın kendisinden değil
              <strong> yerleşim karmasından</strong> çıktı: Temmuz'da trafik bütçesinin <strong>%45'i Story'ye</strong>
              {' '}gitmiş, Ağustos'ta bu oran yalnızca %13. Story, tıklama hedefinde Feed + Reels'ten belirgin
              biçimde pahalı:
            </p>
            <div className="overflow-x-auto rounded-lg border border-sky-200 bg-white mt-2">
              <table className="w-full text-[11px]">
                <thead>
                  <tr className="bg-sky-50/60 text-gray-500 uppercase text-[9px]">
                    <th className="text-left px-3 py-1.5 font-semibold">Yerleşim (Haz–Ağu, trafik)</th>
                    <th className="text-right px-3 py-1.5 font-semibold">Harcama</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPM</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPC (link)</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CTR %</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-sky-100">
                  <tr className="bg-sky-50/40">
                    <td className="px-3 py-1.5 font-semibold text-gray-800">Feed + Reels <span className="font-normal text-gray-400">(plan)</span></td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">₺176.837</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺27,56</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺1,91</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%1,44</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-1.5 font-medium text-gray-700">Story ve diğerleri <span className="text-gray-400">(plan dışı)</span></td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">₺114.701</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺50,87</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺3,32</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%1,53</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Story tıklama başına <strong>~1,7 kat</strong> pahalı. KPI site yönlendirme olduğu için CORALS
              <strong> Feed + Reels'te</strong> planlanır ve plan tabanı da aynı yerleşimden alınır — böylece
              aylar birbiriyle gerçekten kıyaslanabilir hale gelir.
              {M.storyPct != null
                ? <> Bu ayda Story payı gerçekleşen bütçenin <strong>%{M.storyPct}</strong>'iydi.</>
                : <> Bu ay için gerçekleşen bir Story payı yok; plan Story'siz kurulmuştur.</>}
              {' '}Story tamamen kapatılmaz; ilk hafta sonunda küçük bir test
              payıyla açılır, tıklama maliyeti tutarsa ağırlığı artırılır.
            </p>
          </div>

          {/* Video kreatif duyarlılığı */}
          <div data-pdf-section className="rounded-xl border border-orange-200 bg-orange-50 p-4">
            <p className="text-sm font-bold text-gray-800">Duyarlılık — Video Kreatifi Trafiği Pahalılaştırıyor</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Yukarıdaki plan tabanı, {M.forecast ? 'Haziran–Eylül 2026' : M.label} trafik kampanyalarının Feed + Reels ortalamasıdır ve
              o kampanyaların <strong>çoğu statik görsel ve karuseldir</strong>. CORALS ise <strong>üç video</strong> ile
              yayınlanacak. Canon'un trafik hedefli video kampanyalarında gerçekleşen CPM
              {' '}<strong>₺{VIDEO_CPM.toFixed(2)}</strong>, tıklama <strong>₺{VIDEO_CPC.toFixed(2)}</strong> —
              yani ay ortalamasının üzerinde. Gerçekleşme büyük ihtimalle bu iki senaryonun arasında olacaktır.
            </p>
            <div className="grid grid-cols-2 gap-3 mt-3">
              <div className="rounded-lg border border-orange-200 bg-white p-3">
                <p className="text-[10px] font-semibold uppercase text-gray-500">İyimser — ay ortalaması CPM</p>
                <p className="text-lg font-bold text-gray-800 mt-1">{fmtInt(totals.impressions)} <span className="text-xs font-normal text-gray-400">gösterim</span></p>
                <p className="text-[11px] text-gray-600">{fmtInt(totals.clicks)} link tık · CPM ₺{blendedCpm.toFixed(2)} · CPC ₺{blendedCpc.toFixed(2)}</p>
              </div>
              <div className="rounded-lg border border-orange-300 bg-white p-3">
                <p className="text-[10px] font-semibold uppercase text-gray-500">Temkinli — video kreatifi CPM</p>
                <p className="text-lg font-bold text-gray-800 mt-1">{fmtInt(sensImpressions)} <span className="text-xs font-normal text-gray-400">gösterim</span></p>
                <p className="text-[11px] text-gray-600">{fmtInt(sensClicks)} link tık · CPM ₺{VIDEO_CPM.toFixed(2)} · CPC ₺{VIDEO_CPC.toFixed(2)}</p>
              </div>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Temkinli senaryo, iyimserin <strong>%{Math.abs(sensDelta)} altında</strong> gösterim üretir.
              ⚠️ Video kırılımının örneklemi {fmtCur(VIDEO_SAMPLE)} harcamadır (4 kampanya) — yön bilgisi
              olarak güvenilir, nokta tahmini olarak değil. Sunumda taahhüt edilecek rakam temkinli senaryodan seçilmelidir.
            </p>
          </div>

          {/* Ölçüm ön koşulu */}
          <div data-pdf-section className="rounded-xl border border-rose-200 bg-rose-50 p-4">
            <p className="text-sm font-bold text-gray-800">Ölçüm Ön Koşulu — KPI'ın Raporlanabilmesi İçin</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              KPI “web sitesinin ilgili alanına yönlendirme” olduğuna göre plan iki farklı metrikle raporlanabilir
              ve ikisi aynı şey değildir:
            </p>
            <ul className="text-xs text-gray-600 mt-2 space-y-1.5 list-disc pl-5 leading-relaxed">
              <li>
                <strong>Link tıklaması</strong> — Meta tarafında her koşulda ölçülür, ek kurulum gerektirmez.
                Planın taahhüt ettiği metrik budur.
              </li>
              <li>
                <strong>Landing page view (siteye ulaşan ziyaretçi)</strong> — yalnızca hedef sayfada
                <strong> Canon TR piksel'i</strong> varsa ölçülür. World Unseen global bir Canon mülkü olduğu için
                bu piksel orada büyük ihtimalle <strong>yoktur</strong>; o durumda siteye kaç kişinin ulaştığını
                Meta panelinden raporlayamayız.
              </li>
            </ul>
            <p className="text-[11px] text-gray-600 mt-2 leading-relaxed">
              Kampanya başlamadan önce ikisinden biri netleşmeli: <strong>(a)</strong> hedef sayfaya Canon TR
              piksel'i eklenir, ya da <strong>(b)</strong> global'in GA4'üne UTM'li raporlama erişimi alınır.
              Aksi halde global'e “siteye şu kadar kişi geldi” denemez, yalnızca “şu kadar tık gönderildi” denebilir.
            </p>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Referans: Canon'un trafik hedefli video kampanyalarında landing page view / link tıklaması oranı
              <strong> %{(LPV_PER_LINK * 100).toFixed(1)}</strong> gerçekleşmiştir. Bu oran geçerli olursa plan
              ≈ <strong>{fmtInt(totals.lpv)}</strong> siteye ulaşan ziyaret üretir (₺{cplpv.toFixed(2)}).
              Oran hesabın tamamında %0,7 ile %37 arasında salınıyor — ölçüm kurulumu netleşmeden bu rakam
              taahhüt edilmemelidir.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center pt-3 border-t border-gray-100">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-7 w-auto object-contain" />
            <p className="text-[9px] text-gray-400">
              {new Date().toLocaleDateString('tr-TR')} · Confidential · Jellybon × Glowytics
            </p>
            <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-6 w-auto object-contain" />
          </div>
        </div>
      </div>
  );

  if (embedded) return kart;

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between mb-3">
        <div className="flex gap-1.5">
          {Object.values(MONTHS).map((m) => (
            <a
              key={m.slug}
              href={`/budget/canon-corals-${m.slug}-2026`}
              className={`text-[11px] font-semibold px-3 py-1.5 rounded-lg border ${
                m.slug === M.slug
                  ? 'bg-red-50 border-red-200 text-red-700'
                  : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'
              }`}
            >
              {m.short}
              {m.forecast && <span className="ml-1 text-[8px] font-bold opacity-60">tahmin</span>}
            </a>
          ))}
          <a
            href="/budget/canon-corals-2026-tum-aylar"
            className="text-[11px] font-semibold px-3 py-1.5 rounded-lg border bg-gray-900 border-gray-900 text-white hover:bg-gray-800"
          >
            Tümü ↓
          </a>
        </div>
        <button
          onClick={exportPdf}
          disabled={exporting}
          className="text-white text-sm font-semibold px-4 py-2 rounded-lg shadow-sm disabled:opacity-60"
          style={{ background: '#CC0000' }}
        >
          {exporting ? 'PDF Oluşturuluyor…' : 'PDF Olarak İndir'}
        </button>
      </div>
      {kart}
    </div>
  );
}
